"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const helpers_1 = require("../../lib/helpers");
const Badge = (props) => react_1.default.createElement("div", Object.assign({}, helpers_1.usePrimitiveProps(props)));
exports.default = withJourney_1.default('j-badge', Badge);
